import PaymentIssuer from '../models/helperTypes/PaymentIssuer';

export default function isEmptyPaymentIssuer(issuer: PaymentIssuer): boolean {
  return (
    (issuer.idType !== 'J' &&
      (issuer.idNumber === '' ||
        issuer.names === '' ||
        issuer.lastNames === '' ||
        issuer.email === '' ||
        issuer.phoneNumber === '' ||
        issuer.birthday === '' ||
        issuer.gender === '')) ||
    (issuer.idType === 'J' &&
      (issuer.idNumber === '' ||
        issuer.names === '' ||
        issuer.email === '' ||
        issuer.phoneNumber === ''))
  );
}
